"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServeOutcome = exports.VOLLEYBALL_CONFIGURATION = exports.PlayCode = void 0;
var PlayCode;
(function (PlayCode) {
    PlayCode["Point"] = "point";
    PlayCode["Serve"] = "serve";
})(PlayCode = exports.PlayCode || (exports.PlayCode = {}));
exports.VOLLEYBALL_CONFIGURATION = {
    play_codes: Object.values(PlayCode),
};
var ServeOutcome;
(function (ServeOutcome) {
    ServeOutcome["In"] = "in";
    ServeOutcome["Ace"] = "ace";
    ServeOutcome["Error"] = "error";
})(ServeOutcome = exports.ServeOutcome || (exports.ServeOutcome = {}));
//# sourceMappingURL=definitions.js.map